import * as React from 'react';
import {View} from 'react-native';
import {images} from '../../../../../assets/icons';
import {useStyles} from '../../../../hooks/styles';
import {IconLink} from '../iconLink';

interface Props {
  cityName?: string;
  onPress: () => void;
  collapsed?: boolean;
}

export default ({cityName, onPress, collapsed}: Props) => {
  const styles = useStyles(() => ({
    container: {
      ...(!collapsed && {
        flexGrow: 1,
        paddingHorizontal: 20,
      }),
      justifyContent: 'center',
      alignItems: 'center',
    },
    labelStyle: {
      textDecorationLine: 'underline',
    },
  }));

  return cityName ? (
    <View style={styles.container}>
      <IconLink
        testID='city-map-test-id'
        icon={images.MapPoint}
        iconHeight={18}
        iconWidth={18}
        label={collapsed ? undefined : cityName}
        labelStyle={collapsed ? undefined : styles.labelStyle}
        onPress={onPress}
      />
    </View>
  ) : null;
};
